import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import api from "../lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const img = (p) => p?.startsWith("http") ? p : `${BACKEND}${p}`;

export default function Guides() {
    const [guides, setGuides] = useState([]);
    useEffect(() => { api.get("/guides").then(r => setGuides(r.data)).catch(() => {}); }, []);

    return (
        <div data-testid="guides-page" className="bg-cp-ivoire">
            <section className="relative min-h-[65vh] bg-cp-encre text-cp-ivoire overflow-hidden cp-grain">
                <img src={`${BACKEND}/api/static/img/mon_guides_desk.jpg`} alt=""
                    className="absolute inset-0 w-full h-full object-cover cp-kenburns-slow cp-photo-cinematic"/>
                <div className="absolute inset-0 cp-hero-overlay"/>
                <div className="relative z-10 min-h-[65vh] max-w-[1600px] mx-auto px-5 sm:px-6 md:px-12 pt-32 md:pt-40 pb-20 flex flex-col justify-end">
                    <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9 }}>
                        <p className="cp-tiny text-cp-sable mb-8">Les guides</p>
                        <h1 className="cp-serif text-[52px] sm:text-[80px] md:text-[128px] lg:text-[168px] leading-[0.88] tracking-[-0.03em] max-w-5xl">
                            Quatre <em className="cp-display-italic text-cp-sable">carnets.</em><br />
                            Tout ce qu'on <em className="cp-display-italic text-cp-sable">sait.</em>
                        </h1>
                        <p className="cp-serif italic text-base md:text-2xl font-light text-cp-ivoire/90 leading-[1.5] mt-8 max-w-3xl">
                            Des guides digitaux — lisibles en ligne après achat — écrits par la rédaction sur plusieurs années. Sans publicité, sans partenariat caché. Juste ce qu'on donnerait à un ami qui vient nous voir.
                        </p>
                    </motion.div>
                </div>
            </section>

            <section className="py-24 md:py-32 max-w-[1400px] mx-auto px-5 sm:px-6 md:px-12">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16">
                    {guides.map((g, i) => (
                        <motion.article key={g.slug}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.7, delay: (i % 2) * 0.1 }}
                            data-testid={`guide-card-${g.slug}`}>
                            <Link to={`/guides/${g.slug}`} className="group block">
                                <div className="cp-image-zoom aspect-[4/5] bg-cp-craie overflow-hidden mb-6">
                                    <img src={img(g.cover)} alt={g.title} loading="lazy"
                                         className="w-full h-full object-cover cp-photo-cinematic"/>
                                </div>
                                <div className="flex items-baseline justify-between gap-4 mb-4">
                                    <span className="cp-tiny text-cp-terre">Guide digital · {g.pages} pages</span>
                                    <span className="cp-serif italic text-3xl text-cp-foret">{g.price}€</span>
                                </div>
                                <h2 className="cp-serif text-3xl md:text-4xl lg:text-5xl leading-[0.98] tracking-[-0.02em] text-cp-encre mb-3 group-hover:text-cp-terre transition-colors">
                                    {g.title}
                                </h2>
                                <p className="cp-serif italic text-lg text-cp-gris mb-4">{g.subtitle}</p>
                                <p className="cp-serif text-base text-cp-encre/80 leading-snug max-w-xl mb-5">{g.teaser}</p>
                                <span className="cp-tiny text-cp-terre border-b border-cp-terre">Voir le guide →</span>
                            </Link>
                        </motion.article>
                    ))}
                </div>
            </section>

            <section className="bg-cp-encre text-cp-ivoire py-20 md:py-28 cp-grain">
                <div className="max-w-[1000px] mx-auto px-5 sm:px-6 md:px-12 text-center">
                    <p className="cp-tiny text-cp-sable mb-8">Pourquoi ne pas rejoindre le Cercle ?</p>
                    <h3 className="cp-serif text-4xl md:text-6xl leading-[0.95] mb-8">
                        Les 4 guides sont <em className="cp-display-italic text-cp-sable">offerts</em><br/>aux <em className="cp-display-italic">Membres Fondateurs.</em>
                    </h3>
                    <Link to="/club" className="cp-btn-outline-light" data-testid="guides-to-club">Découvrir le Club →</Link>
                </div>
            </section>
        </div>
    );
}
